import { render, staticRenderFns } from "./RoundChatButton.vue?vue&type=template&id=80bf93de&"
import script from "./RoundChatButton.vue?vue&type=script&lang=js&"
export * from "./RoundChatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports